<template>
  <div class="checkbox" @change="toggleState">
    <input id="cbx" type="checkbox" :checked="this.enabled" />
    <label class="toggle" for="cbx"><span></span></label>
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['toggled'],
  setup(props, { emit }) {
    const toggleState = () => {
      emit('toggled');
    };

    return {
      toggleState,
    };
  },
};
</script>
<style>
.checkbox input[type='checkbox'] {
  visibility: hidden;
  display: none;
}

.checkbox .toggle {
  position: relative;
  display: block;
  width: 40px;
  height: 20px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transform: translate3d(0, 0, 0);
}

.checkbox .toggle:before {
  content: '';
  position: relative;
  top: 3px;
  left: 3px;
  width: 34px;
  height: 14px;
  display: block;
  background: #9a9999;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.checkbox .toggle span {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  display: block;
  background: rgb(249, 250, 251);
  border-radius: 10px;
  box-shadow: 0 1px 1px 0 rgb(138 138 138);
  transition: all 0.2s ease;
}

.checkbox .toggle span:before {
  content: '';
  position: absolute;
  display: block;
  margin: -18px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  transform: scale(0);
  opacity: 1;
  pointer-events: none;
}

.checkbox #cbx:checked + .toggle:before {
  background: rgba(45, 212, 191, var(--tw-bg-opacity));
}

.checkbox #cbx:checked + .toggle span {
  transform: translateX(20px);
  transition: all 0.2s cubic-bezier(0.8, 0.4, 0.3, 1.25), background 0.15s ease;
}

.checkbox #cbx:checked + .toggle span:before {
  transform: scale(1);
  opacity: 0;
  transition: all 0.4s ease;
}
</style>
